// API适配器 - 将现有API适配为流程设计器需要的格式
import { getRoles, getRole } from '../role'

/**
 * 获取角色列表 (适配器)
 * @param {Array} ids - 角色ID数组 (可选,暂未使用)
 * @returns {Promise}
 */
// eslint-disable-next-line no-unused-vars
export async function getList(_ids) {
  try {
    const response = await getRoles()
    
    // 适配返回格式
    return {
      success: true,
      data: response || []
    }
  } catch (error) {
    console.error('获取角色列表失败:', error)
    return {
      success: false,
      data: []
    }
  }
}

/**
 * 根据ID获取角色信息
 * @param {number|string} id - 角色ID
 * @returns {Promise}
 */
export async function getById(id) {
  try {
    const response = await getRole(id)
    
    return {
      success: true,
      data: response || {}
    }
  } catch (error) {
    console.error('获取角色详情失败:', error)
    return {
      success: false,
      data: {}
    }
  }
}
